(function () {
  function fixAppointoBtn() {
    const btn = document.querySelector('#appointo-btn');
    if (!btn) return false;

    // Dónde lo queremos colocar (elige el mejor sitio del tema)
    const target =
      document.querySelector('.product__info-container') ||
      document.querySelector('.product__info-wrapper') ||
      document.querySelector('product-info') ||
      document.querySelector('main');

    if (!target) return false;

    // Si ya lo hemos arreglado antes, no repetir
    if (btn.dataset.fixedByGt === '1') return true;
    btn.dataset.fixedByGt = '1';

    // Quitar estilos "flotantes"
    btn.style.position = 'static';
    btn.style.right = 'auto';
    btn.style.left = 'auto';
    btn.style.top = 'auto';
    btn.style.bottom = 'auto';
    btn.style.transform = 'none';
    btn.style.margin = '16px 0';
    btn.style.display = 'block';
    btn.style.width = '100%';
    btn.style.maxWidth = '100%';
    btn.style.zIndex = '1';

    // Meterlo en el sitio correcto (arriba del texto suele quedar bien)
    // Si existe el bloque de cantidad, lo colocamos justo después
    const qty = document.querySelector('.product__info-container .quantity') ||
                document.querySelector('.product__info-container quantity-input');

    if (qty && qty.parentElement) {
      qty.parentElement.insertAdjacentElement('afterend', btn);
    } else {
      target.insertAdjacentElement('afterbegin', btn);
    }

    return true;
  }

  // Ejecutar al cargar
  document.addEventListener('DOMContentLoaded', () => {
    if (fixAppointoBtn()) return;

    // Appointo suele cargar tarde -> observamos el DOM
    const obs = new MutationObserver(() => {
      if (fixAppointoBtn()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Plan B: reintento por si mutación no salta
    setTimeout(fixAppointoBtn, 1000);
    setTimeout(fixAppointoBtn, 2500);
    setTimeout(fixAppointoBtn, 5000);
  });
})();
